/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import { globalFilterDefaults } from '../OhsRegisterConstants';
import { ParamTypes } from '../OhsRegisterModels';

// hasFilter, compare objects if they're equal, used for defaultFilter vs currentFilter
export const returnHasFilter = (defaultObj: any, filterObj: any) => {
  // remove undefined vals
  const defaultValues = _.pickBy(
    { ...globalFilterDefaults, ...defaultObj },
    (v) => v !== undefined
  );
  const filterValues = _.pickBy(filterObj, (v) => v !== undefined);
  const IGNORED_KEYS = [
    ParamTypes.Tab,
    ParamTypes.Page,
    ParamTypes.Next,
    'count',
    'viewPreset',
    ParamTypes.FolderView,
    ParamTypes.Category,
    ParamTypes.Subcategory,
  ];
  let hasFilter = false;

  Object.keys(filterValues).forEach((key) => {
    if (IGNORED_KEYS.includes(key)) {
      return;
    }

    const defaultVal =
      typeof defaultValues[key] === 'string'
        ? defaultValues[key]
        : JSON.stringify(defaultValues[key]);
    const filterVal =
      typeof filterValues[key] === 'string' ? filterValues[key] : JSON.stringify(filterValues[key]);

    if (filterVal && defaultVal !== filterVal) {
      hasFilter = true;
    }
  });

  return hasFilter;
};
